import { useState } from 'react'

import { Member, Role, RoleType } from '@tribeplatform/gql-client/types'
import { MemberPicker } from '@tribeplatform/react-sdk/components'
import { useRoles, useUpdateMember } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'
import { Select } from '@tribeplatform/react-ui-kit/Select'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const AddAdminModal = ({ open, onClose }) => {
  const { mutateAsync: updateMember, isLoading } = useUpdateMember()
  const [members, setMembers] = useState<Member[]>([])
  const [role, setRole] = useState<Role>()
  const { data: roles } = useRoles()

  const memberRole = roles?.filter(role => role.type === RoleType.MEMBER)?.[0]
  const adminRole = roles?.filter(role => role.type === RoleType.ADMIN)?.[0]
  const moderatorRole = roles?.filter(
    role => role.type === RoleType.MODERATOR,
  )?.[0]

  const addAdmins = () => {
    const promises = members.map(async member =>
      updateMember({
        id: member.id,
        input: {
          roleId: role.id,
        },
      })
        .then(() =>
          toast({
            title: 'Member role changed',
            description: `${member?.name}'s role is successfully changed to ${role?.name}.`,
            status: 'success',
          }),
        )
        .catch(() =>
          toast({
            title: 'Something went wrong',
            description: `Cannot change the role of ${member?.name}.`,
            status: 'error',
          }),
        ),
    )

    Promise.all(promises).then(() => onClose())
  }

  return (
    <Modal open={open} onClose={onClose} size="xl">
      <Modal.Header title="Add Admins" />
      <Modal.Content>
        <div className="flex flex-col space-y-2">
          <MemberPicker
            value={members}
            onChange={setMembers}
            multiple
            variables={{
              limit: 20,
              roleIds: [memberRole?.id],
            }}
            placeholder="Select members"
          />
          <Select onChange={setRole} value={role}>
            <Select.Button placeholder="Select role">
              {role?.name}
            </Select.Button>
            <Select.Items>
              {[adminRole, moderatorRole].map(role => (
                <Select.Item key={role.id} value={role}>
                  {role.name}
                </Select.Item>
              ))}
            </Select.Items>
          </Select>
          <div className="flex justify-end space-x-2">
            <Button
              variant="outline"
              onClick={() => {
                onClose()
              }}
              size="lg"
            >
              Cancel
            </Button>
            <Button
              loading={isLoading}
              size="lg"
              onClick={addAdmins}
              disabled={!role || !members.length}
            >
              Add
            </Button>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}
